import gql from 'graphql-tag'

export const fetchProductsQuery = gql`
  query (
    $sku: [String]
    $search: String
    $sort: ProductAttributeSortInput
    $brand: [String]
    $category_id: [String]
    $category_uid: [String]
    $country_of_origin:[String]
    $filter_packaging: [String]
    $packaging: [String]
    $sub_brand: [String]
    $volume: [String]
    $currentPage: Int!
    $pageSize: Int = 25
    $is_peroni: Boolean = false
    $product_last: String
    $product_new: String
    $product_sale: String
  ) {
    products(
      search: $search
      filter: {
        sku: { in: $sku }
        brand: { in: $brand }
        country_of_origin:{ in: $country_of_origin }
        sub_brand: { in: $sub_brand }
        category_id: { in: $category_id }
        category_uid: { in: $category_uid }
        filter_packaging: { in: $filter_packaging }
        packaging: { in: $packaging }
        volume: { in: $volume }
        product_last: { eq: $product_last }
        product_new: { eq: $product_new }
        product_sale: { eq: $product_sale }
      }
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $sort
    ) {
      total_count
      items {
        multi_deposit
        material_type
        number_of_items_in_box
        name
        deliveryDate
        sku
        your_price
        your_price_tax
        favourites
        promo
        product_last
        product_new
        product_sale
        number_of_products_on_layer
        number_of_items_on_pallet
        number_of_layers_per_pallet
        number_of_bottles
        pack_format
        description {
          html
        }
        features @include(if: $is_peroni) {
          tipo_birra
          provenienza
          gradazione_alcolica
          termine_conservazione
        }
        small_image {
          url
        }
        cart_fields {
          packaging_cart
          layer_cart
          pallets_cart
        }
        ... on BundleProduct {
          your_price_sum
          your_price_sum_tax
          bundle_price_sum
          bundle_price_sum_tax
          bundle_fields {
            minimum_amt
            valid_from
            valid_to
            limited_amount
          }
          items {
            option_id
            title
            sku
            type
            required
            position
            your_price_sum
            your_price_sum_tax
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                id
                name
                sku
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                  }
                }
                your_price
                your_price_tax
              }
            }
          }
        }
      }
      page_info {
        page_size
        total_pages
        current_page
      }
    }
  }
`
